import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import {faFileInvoice, faFileSignature} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios/index";
import {withStyles} from "@material-ui/core/styles/index";
import CustomerDetails from "../../components/Customers/CustomerDetails";

const icn = (iconType, classes) => {
    return <FontAwesomeIcon icon={iconType} className={classes.tabBarButtonIcon}/>;
}

const CustomersShow = ({customer, notes, machines, backLink, classes}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={customer.customer_name}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('boards.back'),
                    href: '/customers',
                    onClick: (event) => {
                        event.preventDefault();
                        goBack('/customers');
                    },
                    color: 'secondary',
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('archive.to_archive'),
                    href: `/archive/customer/${customer.id}`,
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('boards.new_note'),
                    href: `/notes/${customer.id}/create`,
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('appointments.new_appointment'),
                    href: `/appointments/${customer.id}/create`
                },
                {
                    icon: 'edit',
                    text: i18n.get('boards.edit'),
                    href: `/customers/${customer.id}/edit`,
                }
            ]}
        />

        <CustomerDetails customer={customer} notes={notes} machines={machines} appointments={customer.appointments}/>

    </Layout>
);

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(CustomersShow);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/customers/Show.jsx